module.exports = ".landing {\n  padding-top: 150px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/register/register.component.scss
// module id = ./src/app/register/register.component.scss
// module chunks = main